import * as PropTypes from 'prop-types';
import * as React from 'react';
import DownloadButton from './download_button';
import Variant from './variant';
import UrlHelpers from '../shared/url_helpers';
import Loading from '../shared/loading';
import { APIRequest } from '@reverbdotcom/discovery-ui';

class StandaloneDownloadButton extends React.Component {
  constructor() {
    super();

    this.state = {
      downloaded: false,
      isLoading: true,
      variants: [],
    };
  }

  componentDidMount() {
    this.fetchDigitalListing();
  }

  get window() {
    return this.props.window || window;
  }

  get variants() {
    return this.state.variants.map(variant => new Variant(variant));
  }

  get loadError() {
    return !(this.state.isLoading || this.variants.length);
  }

  fetchDigitalListing() {
    APIRequest.get(
      UrlHelpers.digitalListingPath(this.props.digitalListingId),
      { },
      { headers: { 'Accept-Version': '3.0' } },
    ).done(response => this.setState({ variants: response.variants, isLoading: false })).fail(() =>
      this.setState({
        isLoading: false,
      }));
  }

  download(fileUrl) {
    this.setState({ downloaded: true });
    this.window.location.href = fileUrl;
    this.window.setTimeout(() => this.setState({ downloaded: false }), 1000);
  }

  render() {
    if (this.loadError) { return null; }

    return (
      <Loading loaded={!this.state.isLoading}>
        <DownloadButton
          variants={this.variants}
          downloadClicked={fileUrl => this.download(fileUrl)}
          gt={this.props.gt}
          downloaded={this.state.downloaded}
        />
      </Loading>
    );
  }
}

StandaloneDownloadButton.propTypes = {
  digitalListingId: PropTypes.number.isRequired,
  gt: PropTypes.string,
  window: PropTypes.object,
};

export default StandaloneDownloadButton;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/standalone_download_button.jsx